<template lang="pug">
  .products-page.grid.col-2
    .left-area
      slot(name="header")
      //- main.info
      //-   .section(
      //-     v-if="shopSections.length && token"
      //-     v-for="(section, index) in shopSections"
      //-     :key="section.id"
      //-     :class="section.key"
      //-   )
      main(:class="{ 'has-sub-menu': visibleFirstLevelMenu }")
        .shop-menu-first-level(
          v-if="visibleFirstLevelMenu"
          :style="{ width: width ? `${width}px` : null }"
        )
          affix.sticky-stuff(
            ref="sticky-nav"
            relative-element-selector="#products-page-sections"
            :scroll-affix="true"
            :offset="{ top: 15, bottom: 15 }"
          )
            nav(ref="nav")
              tree-menu(
                :items="firstLevelItems"
                :active-ids="activeMenuItemIDs"
                :max-depth="1"
                :delay="400"
              )
        #products-page-sections(
          ref="sections"
        )
          section(
            v-for="(section, index) in sections"
            :key="section.id"
            :class="section.key"
          )
            //- Heading(v-if="section.key === 'heading'" :section="section")
            //- Post(v-if="section.key === 'post'" :section="section")
            ProductList(
              v-if="section.key === 'categoryproducts'"
              :section="section"
            )
      //- CartRow
    .right-area.video(v-if="currentVideo")
      Video(
        :data="currentVideo"
        :key="currentVideo.id"
      )
    .right-area.image(v-else-if="currentImage")
      Graphic(
        :data="currentImage"
        :title="currentProduct.name"
        :key="currentImage.id"
      )
    //- empty placeholder
    .right-area.placeholder(v-else)
      .fixed NO MEDIA

    CartRow
    // slot(name="footer")
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import { get, cloneDeep } from '@/helpers';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';
import NestedSet from '@/nested-set-lib';

// import Post from '@/components/Post';
// import Heading from '@/components/Heading';

import ProductList from '@/extensions/shop/components/ProductList';
import CartRow from '@/extensions/shop/components/CartRow';
import Video from '@/extensions/shop/components/Video';
import Graphic from '@/extensions/shop/components/Graphic';

export default {
    name: 'Products',
    data: () => ({
        width: undefined
    }),
    components: {
        // Post,
        // Heading,
        ProductList,
        Authenticate,
        Video,
        Graphic,
        CartRow
    },
    computed: {
        currentProduct() {
            if (this.focusedMedia && this.focusedMedia.product) return this.focusedMedia.product;
            return this.activeProduct;
        },
        currentMedia() {
            let media;
            if (this.activeProduct && this.activeProduct.media && this.activeProduct.media.length) {
                // get the "main" media object (is marked for list view)
                // media = this.activeProduct.media.find(el => get(el, 'settings.show.list', true) === true);

                // custom for Rundholz:
                // get the "main" media object (is video)
                media =
                    this.activeProduct.media.find(el => {
                        return get(el, 'settings.show.list', true) === true && get(el, 'type') === 'video';
                    }) ||
                    this.activeProduct.media.find(el => {
                        return get(el, 'settings.show.detail', true) === true && get(el, 'type') === 'video';
                    }) ||
                    this.activeProduct.media.find(el => {
                        return get(el, 'settings.show.list', true) === true;
                    });
            }

            return media;
        },
        currentVideo() {
            let video;
            if (this.focusedMedia) {
                if (this.focusedMedia.type === 'video') video = this.focusedMedia.video;
            } else if (this.currentMedia && this.currentMedia.type === 'video') {
                video = this.currentMedia.video;
            }
            return video;
        },
        currentImage() {
            let image;
            if (this.focusedMedia) {
                if (this.focusedMedia.type === 'image') image = this.focusedMedia.image;
            } else if (this.currentMedia && this.currentMedia.type === 'image') {
                image = this.currentMedia.image;
            }
            return image;
        },
        // mainSections() {
        //   return this.sections.filter(section => {
        //     return (
        //       section.area === 'main' &&
        //       (section.key === 'heading' || section.key === 'post' || section.key === 'categoryproducts')
        //     );
        //   });
        // },
        // shopSections() {
        //   return this.sections.filter(section => {
        //     return section.area === 'shoppinginfo' && section.key === 'videostreaming'
        //   })
        // },
        // cartHasItems() {
        //   if (this.cart && this.cart.qty) return true;
        //   return false;
        // },
        // categoryItems() {
        //   let items = cloneDeep(this.categories);

        //   if (items.length) {
        //     return NestedSet.createTree(items);
        //   }

        //   return null;
        // },
        // items() {
        //   let items = [];

        //   const menu = this.menus.find(menu => menu.key === 'main-menu');
        //   items = get(menu, 'menuItems') || [];
        //   items = cloneDeep(items);

        //   if (items.length) {
        //     items = NestedSet.createTree(items);
        //   }

        //   return items;
        // },
        firstLevelItems() {
            let tree;

            if (this.activeMenuItemIDs && this.activeMenuItemIDs.length) {
                const rootID = this.activeMenuItemIDs[0];

                let items = [];
                const menu = this.menus.find(menu => menu.key === 'main-menu');
                items = get(menu, 'menuItems') || [];
                items = cloneDeep(items);

                if (items.length) {
                    const full = NestedSet.createTree(items);
                    if (full && full.length) {
                        const item = full.find(el => el.id === rootID);
                        if (item && item.children && item.children.length) tree = item.children;
                    }
                }
            }

            return tree;
        },
        visibleFirstLevelMenu() {
            const items = this.firstLevelItems || [];
            return items.filter(item => !item.disabled && !item.hidden).length > 0;
        },
        activeMenuItemIDs() {
            let IDs = [];

            const menus = this.menus || [];
            const menu = menus.find(menu => menu.key === 'main-menu');
            const items = get(menu, 'menuItems') || [];

            const path = this.$route.path;
            const item = items.find(el => el.path === path);

            if (item) {
                const ancestors = NestedSet.getAncestors(cloneDeep(items), item);
                IDs = [...ancestors, item].map(el => el.id);
            }

            return IDs;
        },
        ...mapGetters({
            sections: 'sections',
            menus: 'menus',
            // cart: 'shop/cart',
            token: 'auth/token',
            activeProduct: 'shop/activeProduct',
            focusedMedia: 'shop/focusedMedia',
            // categories: 'shop/categories',
            widescreen: 'shop/widescreen',
            tailwind: 'tailwind'
            // clearVisibleProducts: 'shop/clearVisibleProducts',
            // removeFocusedMedia: 'shop/removeFocusedMedia',
        })
    },
    methods: {
        ...mapMutations({
            setWidescreen: 'shop/setWidescreen'
        })
    },
    mounted() {
        const widescreen = get(
            this.tailwind.theme.screens.widescreen.raw.match(
                /min-aspect-ratio: (?<w>[1-9]+?[0-9]*)\/(?<h>[1-9]+?[0-9]*)/
            ),
            'groups'
        );
        const ratio = parseFloat(widescreen.w) / parseFloat(widescreen.h);
        const lg = parseInt(this.tailwind.theme.screens.lg);

        const checkWidescreen = () => {
            const widescreen = window.innerWidth / window.innerHeight >= ratio && window.innerWidth >= lg;
            if (widescreen !== this.widescreen) this.setWidescreen(widescreen);

            // TODO
            // find the reason for this nasty workaround
            this.$nextTick(() => {
                if (this.$refs.nav) {
                    if (window.innerWidth >= lg) this.width = this.$refs.nav.clientWidth;
                }
            });
        };

        // window.addEventListener('resize', debounce(checkWidescreen, 100));
        window.addEventListener('resize', checkWidescreen);
        setTimeout(checkWidescreen, 150);
        // checkWidescreen();
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.products-page
  flex-grow: 1
  width: 100%
  @screen widescreen
    @screen lg
      grid-template-rows: auto
      grid-template-columns: minmax(0, $leftWidth) $rightWidth
  .left-area
    min-height: 100vh
    max-width: 100%
    display: flex
    flex-direction: column
    @screen lg
      padding-bottom: 5rem
    section, .items
      display: flex
      flex-direction: column
      flex-grow: 1
  .right-area
    display: none
    @screen widescreen
      @screen lg
        display: flex
        // padding-bottom: 51px
        background: $skeletonColor
        // background: var(--color-primary)
        &.video::v-deep
          .video-container
            // padding: 1rem
            width: $rightWidth
        &.image::v-deep
          .graphic
            padding: 1rem
            width: $rightWidth
            .image
              width: calc(#{$rightWidth} - 2rem)
        &.placeholder .fixed
          @apply text-gray-700 flex items-center justify-center
          width: $rightWidth
          height: 100vh
          padding-bottom: 51px
  main
    display: flex
    // flex-direction: row
    flex-grow: 1
    padding: 1rem
    @screen lg
      padding: 1rem 3rem
      //- @screen widescreen
      //-   padding-right: 10rem
      &.has-sub-menu
        display: grid
        grid-template-rows: 100%
        grid-template-columns: max-content minmax(0, 100%)
        grid-gap: 1rem
    .shop-menu-first-level
      display: none
      @screen lg
        display: initial
      nav > ul.tree-menu
        display: flex
        flex-direction: column
        &::v-deep > li
          display: inline-block
          width: auto
          max-width: 180px
          margin-bottom: 3px
          &.hover
            @apply outline-black-sm
          & > .tree-item > a
            width: 100%
            padding: 4px 6px 6px
            border: 1px solid var(--color-primary)
            display: inline-block
            line-height: 1
            text-align: left
            font-weight: bold
            transition: background .15s ease, color .15s ease
          &.active > .tree-item > a
            color: white !important
            background: black
    #products-page-sections
      @apply flex flex-grow flex-col
      width: 100%
</style>
